import slugify from '../functions/slugify'

export default ({ Vue }) => {
    Vue.prototype.$slugify = slugify
}
